export default __webpack_public_path__ + "static/media/venus.2bd76e7d.jpg";